import { Builder } from '@builder.io/react'
import React from 'react'

enum FillerPos {
  Top = 'Top',
  Bottom = 'Bottom'
}

enum HeightSize {
  ExtraExtraSmall = 'ExtraExtraSmall',
  ExtraSmall = 'ExtraSmall',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}

export interface IBackgroundFillerProps {
  backgroundColor: string
  heightSize: HeightSize
  fillerImage: any
  fillerImagePos: FillerPos
  fillerImagePosAmount: number
  enableComplimentImage: boolean
  complimentImage: any
  complimentImageFill?: 'cover' | 'contain'
}

const BackgroundFiller = ({
  backgroundColor,
  heightSize,
  fillerImage,
  fillerImagePos,
  fillerImagePosAmount,
  enableComplimentImage,
  complimentImage,
  complimentImageFill = 'contain'
}: IBackgroundFillerProps) => {
  console.log('FILLER IMAGE', fillerImage)
  const getHeight = () => {
    let heightClass = 'h-20 md:h-40'
    if (heightSize == HeightSize.ExtraExtraSmall) {
      heightClass = 'h-5 md:h-10'
    }
    if (heightSize == HeightSize.ExtraSmall) {
      heightClass = 'h-10 md:h-20'
    }
    if (heightSize == HeightSize.Small) {
      heightClass = 'h-20 md:h-40'
    }
    if (heightSize == HeightSize.Medium) {
      heightClass = 'h-40 md:h-60'
    }
    if (heightSize == HeightSize.Large) {
      heightClass = 'h-60 md:h-80'
    }
    return heightClass
  }

  const positionStyleObj = () => {
    if (fillerImagePos === FillerPos.Top) {
      return { top: `${fillerImagePosAmount}%` }
    }
    return { bottom: `${fillerImagePosAmount}%` }
  }

  const getComplimentImage = () => {
    if (enableComplimentImage) {
      return (
        <img
          src={complimentImage}
          className={`absolute top-1/2 left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 object-${complimentImageFill}`}
          alt=""
        />
      )
    }
    return null
  }

  return (
    <div className={`relative w-full ${getHeight()} overflow-hidden`} style={{ backgroundColor }}>
      <img src={fillerImage} className={`absolute w-full object-cover`} style={{ ...positionStyleObj() }} alt="" />
      {getComplimentImage()}
      {/* <ReactSVG src={fillerImage} afterInjection={handleInjection} /> */}
    </div>
  )
}

export default BackgroundFiller

export const BackgroundFillerProps = {
  name: 'BackgroundFiller',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'heightSize',
      type: 'string',
      enum: ['ExtraExtraSmall', 'ExtraSmall', 'Small', 'Medium', 'Large'],
      defaultValue: 'Small'
    },
    {
      name: 'fillerImage',
      type: 'file',
      defaultValue: null,
      allowedFileTypes: ['png', 'jpeg', 'svg'],
      description: 'The wavy shape for the filler'
    },
    {
      name: 'fillerImagePos',
      type: 'string',
      enum: ['Top', 'Bottom'],
      defaultValue: 'Bottom'
    },
    {
      name: 'fillerImagePosAmount',
      type: 'number',
      defaultValue: 50
    },
    {
      name: 'enableComplimentImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'complimentImage',
      type: 'file',
      defaultValue: null,
      allowedFileTypes: ['png', 'jpeg', 'svg'],
      description: 'Image on top of filler image'
    },
    {
      name: 'complimentImageFill',
      type: 'text',
      enum: ['cover', 'contain'],
      defaultValue: 'contain'
    }
  ]
}

Builder.registerComponent(BackgroundFiller, {
  ...BackgroundFillerProps
})
